import { createFileRoute } from "@tanstack/react-router";
import { areasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { DatosGeneralesPage } from "@/features/datos-generales/components/DatosGeneralesPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/datos-generales")({
  loader: ({ context: { queryClient }, params: { id } }) => Promise.all([queryClient.ensureQueryData(solicitudQueryOptions(id)), queryClient.ensureQueryData(areasQueryOptions)]),
  component: DatosGeneralesPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
